"use client";

import { Button } from "ui/components/button";

import Icon from "./icon";
import { INBOX } from "icons";
import { cn } from "utils";
import classNames from "classnames";

export function EmptySection1({
  title = "No entry found",
  icon = INBOX,
  className,
  children,
  description,
  variant,
}) {
  return (
    <section
      className={cn("bg-background py-1 md:px-4 px-4 w-full flex-1", className)}
    >
      {/* Add border border-border shadow-sm and rounded-lg class to make this section look like a card */}
      <div className="w-full flex flex-col justify-center items-center gap-6 p-6 rounded-lg border border-dashed flex-1 ">
        <div className="w-12 h-12 flex items-center justify-center rounded-md bg-card border shadow-sm p-2">
          <Icon icon={icon} className="h-6 w-6 text-foreground" />
        </div>

        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            {title}
          </h2>
          {description && (
            <p
              className={classNames(
                "text-sm text-muted-foreground leading-5 max-w-xl",
                variant === "alert" && "text-red-500"
              )}
            >
              {description}
            </p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
}
export function EmptySection({
  title = "No entry found",
  icon = INBOX,
  className,
  description,
}) {
  return (
    <section
      className={cn("bg-background py-1 md:px-4 px-4 w-full flex-1", className)}
    >
      {/* Add border border-border shadow-sm and rounded-lg class to make this section look like a card */}
      <div className="w-full flex flex-col justify-center items-center gap-6 p-6 rounded-lg border border-dashed flex-1 ">
        <div className="w-12 h-12 flex items-center justify-center rounded-md bg-card border shadow-sm p-2">
          <Icon icon={icon} className="h-6 w-6 text-foreground" />
        </div>

        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            {title}
          </h2>
          {description && (
            <p className="text-sm text-muted-foreground leading-5 max-w-xl">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
